import SignupList from './components/SignupList';
//import SignInForm from './components/SignInForm';
//import Guidelines from './components/Guidelines';
import classes from './App.module.css';

function App() {
	var userData = { firstname: "", lastname: "", email: "", signedIn: false };
	if (typeof window.reactPress !== "undefined" && window.reactPress.usermeta !== "") {
		console.log(window.reactPress.usermeta);
		console.log(window.reactPress.user);
		userData={
			firstname: window.reactPress.usermeta.last_name[0],
			lastname: window.reactPress.usermeta.first_name[0],
			email: window.reactPress.user.data.user_email,
			signedIn: true
		};	
	}

	if (window.location.host.slice(0, 5) === "local") {
		userData = {
			firstname: "Steve",
			lastname: "Schrader",
			email: "sas549@me.com",
			signedIn: true
		};
	}
/*

var reactPress = {"api":{"nonce":"c0eb7faebb","rest_url":"https:\/\/abrightspot.org\/wp-json\/","graphql_url":"https:\/\/abrightspot.org\/graphql"},"post":{"ID":1845,"post_author":"2","post_date":"2024-07-05 18:51:26","post_date_gmt":"2024-07-05 18:51:26","post_content":"<!-- wp:html -->\n<!-- Please don't change. Block is needed for React app. -->\n<noscript>You need to enable JavaScript to run this app.<\/noscript>\n<div id=\"root\"><\/div>\n<!-- \/wp:html -->","post_title":"test","post_excerpt":"","post_status":"publish","comment_status":"closed","ping_status":"closed","post_password":"","post_name":"test","to_ping":"","pinged":"","post_modified":"2024-07-08 13:13:23","post_modified_gmt":"2024-07-08 13:13:23","post_content_filtered":"","post_parent":0,"guid":"https:\/\/abrightspot.org\/?page_id=1845","menu_order":0,"post_type":"page","post_mime_type":"","comment_count":"0","filter":"raw"},
"user":{"data":{},"ID":0,"caps":[],"cap_key":null,"roles":[],"allcaps":[],"filter":null},
"usermeta":""};
*/
	
	return (
		<div className={classes.pageDiv}>
			<div className={classes.inner}>
				<div className={classes.SignupDiv}>
					<SignupList {...userData} />
				</div>
			</div>
		</div>
	)
}

export default App;
